import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-responsive-modal'
import { connectModal, hide } from 'redux-modal'
import { useDispatch } from 'react-redux'
import styled from 'styled-components/macro'
import LightButton from 'components/ui/LightButton'

const CloseIcon = styled.i`
  font-size: 20px;
  color: #ffffff;
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 10px;
  cursor: pointer;
`
const Icon = styled.i`
  font-size: 20px;
  color: #ffffff;
  padding: 10px;
`

const ModalTitle = styled.h3`
  margin-top: 0;
  font-size: 22px;
  margin-bottom: 10px;
  text-transform: none;
`
const ModalContent = styled.div`
  padding-top: 20px;
  margin-top: 10px;
  font-family: 'Open Sans';
  font-size: 14px;
  max-width: 310px;
`

const ButtonContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  max-width: 300px;
`
const modalStyles = {
  modal: {
    backgroundColor: '#003399',
    color: '#ffffff',
    minWidth: '250px',
    borderRadius: '4px',
    boxShadow:
      '0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px 0 rgba(0,0,0,0.2)'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.15)'
  },
  closeButton: {}
}

function AlertModal({ show, title, message }) {
  const dispatch = useDispatch()
  return (
    <div>
      <Modal
        styles={modalStyles}
        open={show}
        showCloseIcon={false}
        onClose={() => {
          dispatch(hide('alertModal'))
        }}
        center
      >
        <CloseIcon
          onClick={() => {
            dispatch(hide('alertModal'))
          }}
          className="far fa-times"
        />
        <ModalContent>
          <ModalTitle>
            <Icon className="far fa-engine-warning" />
            {title}
          </ModalTitle>
          <div>{message}</div>
        </ModalContent>
        <ButtonContainer>
          <LightButton
            size="medium"
            color="#003399"
            background="#ffffff"
            hoverBgColor="#ffffff"
            onClick={() => {
              dispatch(hide('alertModal'))
            }}
          >
            OK
          </LightButton>
        </ButtonContainer>
      </Modal>
    </div>
  )
}

AlertModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

export default connectModal({ name: 'alertModal' })(AlertModal)
